import React from 'react';
import Breadcrumbs from './breadcrumbs';
import Locations from './locations';
import Paths from '../../shared/components/paths';
import Metatags from './meta-tags';
import Keywords from './keywords';
import FooterLinks from './footer-links';
import FooterSearch from './footer-search';
import ZAddButton from '../../z-button-add';

const rowStyle = {
  display: 'flex',
  width: '100%',
  justifyContent: 'space-between',
};

const OptimizationView = ({
  entityId,
  keywordsExclude,
  keywordsInclude,
  setKeywordsExclude,
  setKeywordsInclude,
  title,
  onFooterSearch,
  scrollTargetEle,
  onTopSectionClick,
}) => {
  return (
    <>
      <h2>Admin Settings</h2>
      <Paths
        entityId={entityId}
        entityTitle={title}
        entityType="CompanyCategory"
        pathPrefix=""
      />
      <br/>
      <Breadcrumbs
        entityId={entityId}
      />
      <p style={{ fontSize: '14px', margin: '10px 10px 0' }}>*Parent landing page sets breadcrumb</p>
      <br/>
      <div style={rowStyle}>
        <Locations
          entityId={entityId}
        />
      </div>
      <br />
      <div style={rowStyle}>
        <Keywords
          key="include"
          keywords={keywordsInclude}
          setKeywords={setKeywordsInclude}
          title="Keywords to Include"
        />
        <Keywords
          key="exclude"
          keywords={keywordsExclude}
          setKeywords={setKeywordsExclude}
          title="Keywords to Exclude"
        />
      </div>
      <br/>
      <Metatags
        entityId={entityId}
      />
      <br/>
      <h3>SEO Footer Links</h3>
      <FooterSearch
        onFooterSearch={onFooterSearch}
      />
      <br/>
      <div style={{display: 'flex', flexDirection: 'row-reverse'}}>
        <ZAddButton onClick={onTopSectionClick}>Add Section</ZAddButton>
      </div>
      <br/>
      <FooterLinks
        entityId={entityId}
      />
      <div ref={scrollTargetEle}/>
      <br/>
    </>
  )
}

export default OptimizationView;
